var map = {
	"./pages/admin-credit/admin-credit.module": [
		"./src/app/pages/admin-credit/admin-credit.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-admin-credit-admin-credit-module"
	],
	"./pages/assign-plan/assign-plan.module": [
		"./src/app/pages/assign-plan/assign-plan.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"default~pages-assign-plan-assign-plan-module~pages-deduction-history-deduction-history-module~pages-~c17fcad1",
		"pages-assign-plan-assign-plan-module"
	],
	"./pages/client-verification/client-verification.module": [
		"./src/app/pages/client-verification/client-verification.module.ts",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"pages-client-verification-client-verification-module"
	],
	"./pages/currency-conversion/currency-conversion.module": [
		"./src/app/pages/currency-conversion/currency-conversion.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-currency-conversion-currency-conversion-module"
	],
	"./pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-dashboard-dashboard-module"
	],
	"./pages/deduction-history/deduction-history.module": [
		"./src/app/pages/deduction-history/deduction-history.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"default~pages-assign-plan-assign-plan-module~pages-deduction-history-deduction-history-module~pages-~c17fcad1",
		"pages-deduction-history-deduction-history-module"
	],
	"./pages/email/email.module": [
		"./src/app/pages/email/email.module.ts",
		"pages-email-email-module"
	],
	"./pages/extra-credit/extra-credit.module": [
		"./src/app/pages/extra-credit/extra-credit.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-extra-credit-extra-credit-module"
	],
	"./pages/invoices/invoices.module": [
		"./src/app/pages/invoices/invoices.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-invoices-invoices-module"
	],
	"./pages/lang/lang.module": [
		"./src/app/pages/lang/lang.module.ts",
		"pages-lang-lang-module"
	],
	"./pages/licence/licence.module": [
		"./src/app/pages/licence/licence.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"pages-licence-licence-module"
	],
	"./pages/pay-as-you-go/pay-as-you-go.module": [
		"./src/app/pages/pay-as-you-go/pay-as-you-go.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"pages-pay-as-you-go-pay-as-you-go-module"
	],
	"./pages/payasyougo/payasyougo.module": [
		"./src/app/pages/payasyougo/payasyougo.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-payasyougo-payasyougo-module"
	],
	"./pages/pricing-history/pricing-history.module": [
		"./src/app/pages/pricing-history/pricing-history.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"default~pages-assign-plan-assign-plan-module~pages-deduction-history-deduction-history-module~pages-~c17fcad1",
		"pages-pricing-history-pricing-history-module"
	],
	"./pages/sales-and-vouchers/sales-and-vouchers.module": [
		"./src/app/pages/sales-and-vouchers/sales-and-vouchers.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-sales-and-vouchers-sales-and-vouchers-module"
	],
	"./pages/standard-checks/standard-checks.module": [
		"./src/app/pages/standard-checks/standard-checks.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-standard-checks-standard-checks-module"
	],
	"./pages/standard-service/standard-service.module": [
		"./src/app/pages/standard-service/standard-service.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-standard-service-standard-service-module"
	],
	"./pages/stats/module": [
		"./src/app/pages/stats/module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-stats-module"
	],
	"./pages/stp-config/stp-config.module": [
		"./src/app/pages/stp-config/stp-config.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-stp-config-stp-config-module"
	],
	"./pages/stp-pending-review/module": [
		"./src/app/pages/stp-pending-review/module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-deduction-history-deduction-history-module~pages-~c17fcad1",
		"pages-stp-pending-review-module"
	],
	"./pages/subscription-plan/subscription-plan.module": [
		"./src/app/pages/subscription-plan/subscription-plan.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"pages-subscription-plan-subscription-plan-module"
	],
	"./pages/tax/tax.module": [
		"./src/app/pages/tax/tax.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"pages-tax-tax-module"
	],
	"./pages/theme/theme.module": [
		"./src/app/pages/theme/theme.module.ts",
		"pages-theme-theme-module"
	],
	"./pages/user-licence/user-licence.module": [
		"./src/app/pages/user-licence/user-licence.module.ts",
		"default~pages-admin-credit-admin-credit-module~pages-assign-plan-assign-plan-module~pages-currency-c~01e7f3fd",
		"default~pages-assign-plan-assign-plan-module~pages-client-verification-client-verification-module~pa~6fb1a141",
		"pages-user-licence-user-licence-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;